<template>
	<div class="forget">
    <el-card class="box-card">
			<div class="min-body">
				<el-row>
					<el-col>
						<h1 class="header-h1">找回密码</h1>
					</el-col>
				</el-row>
				<el-row class="row-margin-30">
					<el-col :span="8">
						<span class="step" :class="step === 1 ? 'active' : ''">1 填写账户</span>
					</el-col>
					<el-col :span="8">
						<span class="step" :class="step === 2 ? 'active' : ''">2 设置新密码</span>
					</el-col>
					<el-col :span="8">
						<span class="step" :class="step === 3 ? 'active' : ''">3 修改成功</span>
					</el-col>
				</el-row>
				<el-row class="row-margin-30">
					<el-col class="custom-form">
						<!-- 填写账户 -->
						<template v-if="step === 1">
							<el-form ref="formStep1" size="small" :rules="formStep1Rules" :model="formStep1" label-width="120px">
								<el-form-item label="邮箱账户" prop="email" class="custom-append">
									<div class="custom-form-item">
										<el-input v-model="formStep1.email" disabled placeholder="邮箱账户"/>
									</div>
									<div class="can-not-email" @click="notUseEmail()">不知道邮箱名，重新激活</div>
								</el-form-item>
								<el-form-item label="图形验证码" prop="imgCode">
									<div class="custom-form-item custom-form-item-append">
										<el-input placeholder="请输入图形验证码" v-model="formStep1.imgCode" :maxlength="4">
											<template slot="append">
												<img class="custom-form-item-img" :src="imgUrl" alt="图形验证码" @click="initImgCode()">
											</template>
										</el-input>
									</div>
								</el-form-item>
								<el-form-item label="邮箱验证码" prop="code">
									<div class="custom-form-item">
										<el-input placeholder="请输入验证码" v-model="formStep1.code" :maxlength="6">
											<template slot="append">
												<el-button class="btn-code" v-if="countout" type="danger">{{countout}}</el-button>
												<el-button class="btn-code" v-else @click="sendEmailCode()" type="danger">发送验证码</el-button>
											</template>
										</el-input>
									</div>
								</el-form-item>
								<el-form-item>
									<el-button @click="firstNext()" type="danger">下一步</el-button>
								</el-form-item>
							</el-form>
						</template>
						<!-- 填写账户 -->
						<template v-if="step === 2">
							<el-form ref="formStep2" size="small" :rules="formStep2Rules" :model="formStep2" label-width="120px">

								<!-- 去掉浏览器自带账户和密码 -->
								<el-form-item label="用户名" style="display: none">
									<el-input type="text" size="small" name="username"
									placeholder="请输入用户名" :clearable="true" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="密码" style="display: none">
									<el-input type="password" size="small" name="password"
									placeholder="请输入密码" :clearable="true" autocomplete="off"></el-input>
								</el-form-item>
								<el-form-item label="密码" style="display: none">
									<el-input type="password" size="small" name="password"
									placeholder="请输入密码" :clearable="true" autocomplete="off"></el-input>
								</el-form-item>
								<!-- 上面这段代码必须要 -->

								<el-form-item label="登录账号">
									<el-input v-model="formStep2.email" disabled placeholder="邮箱账户"/>
								</el-form-item>
								<el-form-item label="新密码" prop="password">
									<el-input v-model="formStep2.password" type="password" :maxlength="16"
														placeholder="新密码"/>
								</el-form-item>
								<el-form-item label="再次输入新密码" prop="password2">
									<el-input v-model="formStep2.password2" type="password" :maxlength="16"
														placeholder="再次输入新密码"/>
								</el-form-item>
								<el-form-item label="联系手机" prop="phone">
									<el-input v-model="formStep2.phone" placeholder="联系手机" :maxlength="11"/>
								</el-form-item>
								<el-form-item>
									<el-button @click="secondNext()" type="danger">确认</el-button>
								</el-form-item>
							</el-form>
						</template>
						<!-- 填写账户 -->
						<template v-if="step === 3">
							<p>密码修改成功，立即前往登录！</p>
							<el-button type="danger" class="btn">确认</el-button>
						</template>
						
					</el-col>
				</el-row>
			</div>
    </el-card>
  </div>
</template>

<script>
import {ApiMethods} from '@/assets/js/http-serve/http-methods';
export default {
	name: 'forget',
  layout: 'user',
	data () {
		return {
			// step
			imgToken: '',
			imgUrl: '',
			step: 1,
			formStep1: {
				email: '',
				emailSec: '',
				imgCode: '',
				code: ''
			},
			formStep1Rules: {
				imgCode: [
					{ validator: this.$validator.required,trigger: ['change','blur'],message: '图形验证码不能为空' },
					{ validator: this.$validator.lengthRank,trigger: ['change','blur'], minLength: 4, maxLength: 4, message: '输入4位图形验证码' }
				],
				code: [
					{ validator: this.$validator.required,trigger: ['change','blur'],message: '验证码不能为空' },
					{ validator: this.$validator.lengthRank,trigger: ['change','blur'], minLength: 6, maxLength: 6, message: '输入6位验证码' }
				]
			},
			// 是否发送邮箱验证码 10s
			timer: null,
			countout: 0,

			// ------------------------------------
			// 第二步
			formStep2: {
				sign: '', // V6x3AG9N05sOlhGxLD3Qkl_MeC3RIbPIhdM1EIAkFQ0
				ts: '', // 1548380970863
				email: '',
				password: '',
				password2: '',
				phone: ''
			},
			formStep2Rules: {
				password: [
					{ validator: this.$validator.required, trigger: ['change','blur'],	message: '密码不能为空' },
					{ validator: this.$validator.lengthRank, trigger: ['change','blur'], minLength: 6, maxLength: 16,	message: '输入6到16位密码' },
					{ validator: this.$validator.password, trigger: ['change','blur'], message: '密码不能包含空格并且不能为纯数字' }
				],
				password2: [
					{ validator: this.$validator.required, trigger: ['change','blur'], message: '重复密码不能为空' },
					{ validator: (rule, val, cb) => {
							if (cb === '') {
								cb('请再次输入密码')
							} else if (val !== this.formStep2.password) {
								cb(new Error('两次输入密码不一致!'))
							} else {
								cb()
							}
						}, trigger: ['change','blur']
					}
				],
				phone: [
					{ required: true, message: '联系手机不能为空', trigger: ['change','blur'] },
					{ min: 11, max: 11, message: '联系手机必须是11位', trigger: ['change','blur'] },
					{ validator: this.$validator.mobile, trigger: ['change','blur'] }
				]
			}
		}
	},
	components: {},
	created(){
		
	},
	watch: {},
	computed: {},
	mounted(){
		
		let query = this.$route.query
		if (query.email && query.emailSec) {
			this.formStep1.email = query.email
			this.formStep1.emailSec = query.emailSec
		}

		this.initTimer()
		this.initImgCode()
	},
	methods: {
		// 初始化定时器
		initTimer() {
			let now = +new Date()
			let last = localStorage.getItem('accountPasswordForgetTimer')
			let out = 120
			if (last) {
				last = parseInt(last)
				out = parseInt((now - last)/1000)
			} 
			if (out >= 120) {
				this.timer = null
				this.countout = 0
			} else {
				this.startUpInterval(120 - out)
			}
		},
		// 启动定时器
		startUpInterval(v) {
			if (v) {
				this.countout = v
			} else {
				this.countout = 120
				localStorage.setItem('accountPasswordForgetTimer', +new Date())
			}
			this.timer = setInterval(() => {
				this.countout --
				if (this.countout === 0) {
					clearInterval(this.timer)
					this.timer = null
				}
			}, 1000)
		},
		initImgCode() {
			let param = {verifyType: 3}
			ApiMethods.VerifyController.imgCode(param).then(result => {
				if (result.success) {
					this.imgUrl = "data:image/jpeg;base64," + result.data.imgPath;
					this.imgToken = result.data.imgToken;
				} else {
					this.$message.error(result.description || this.$tip)
				}
			})
		},
		// 发送验证码
		sendEmailCode() {
			this.$refs['formStep1'].validateField('imgCode', valid => {
				if (!valid) {
					let param = {
						targetId: this.formStep1.emailSec,
						verifyType: 3,
						ifDecode: 1, // 发送方式是否加密:0或null不加密,1加密
						imgCode: this.imgToken + '_' + this.formStep1.imgCode
					}
					ApiMethods.VerifyController.sendCode(param).then(result => {
						if (result.code === '0') {
							this.startUpInterval()
						} else {
							this.$message.error(result.description)
							this.initImgCode()
						}
					}).catch(error => {
						this.$message.error(error.description)
					})
				}
			})
		},
		// 第一步里的下一步
		firstNext() {
			// this.step = 2;
			// return
			this.$refs['formStep1'].validate(valid => {
				if (valid) {
					let param = {
						verifyType: 3,
						targetId: this.formStep1.emailSec,
						valicode: this.formStep1.code,
						ifDecode: 1
					};
					ApiMethods.AnonyController.secSign(param).then(result => {
						if (result.success) {
							this.formStep2.sign = result.data.sign;
							this.formStep2.ts = result.data.ts;
							this.formStep2.email = result.data.targetId
							this.step = 2;
						} else {
							this.$message.error(result.description || this.$tip);
						}
					})
				}
			})
		},

		// -------------------------
		// 确认密码
		secondNext() {
			// if (!this.formStep2.sign || !this.formStep2.ts) {
			// 	return this.$message.error('请填写第一步验证码')
			// }
			this.$refs['formStep2'].validate(valid => {
				if (valid) {
					let param = {}
					param.targetId  = this.formStep1.emailSec
					param.pwd = this.formStep2.password
					param.sign = this.formStep2.sign
					param.ts = this.formStep2.ts
					param.ifDecode = 1
					ApiMethods.AnonyController.pwdRest(param).then(result => {
						if (result.success) {
							this.$alert('密码修改成功,立即前往登录?', '系统提示', {
								confirmButtonText: '确定',
								callback: action => {
									this.$router.push({path: '/login'})
								}
							})
						} else {
							this.$message.error(result.description || this.$tip);
						}
					})
				}
			})
		},

		// 无法使用邮箱
		notUseEmail() {
			this.$confirm('为确保用户数据安全,您需要身份验证后才能继续操作', '系统提示', {
				confirmButtonText: '继续',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$router.push({
					path: '/account/password/authentication',
					query: {
						email: this.formStep1.email,
						emailSec: this.formStep1.emailSec
					}
				})
			}).catch(() => {})
		}
	},
	beforeDestroy(){
		if (this.timer) {
			clearInterval(this.timer)
			this.timer = null
			this.countout = 0
		}
	}
}
</script>

<style scoped>
	.custom-form-item-append >>> .el-input-group__append {
		padding: 0;
	}
	.custom-form-item {
		position: relative;
		width: 240px;
	}
	.custom-form-item-img{
		width: 97px;
    height: 30px;
	}
	.btn-code {
		width: 97px;
	}

	.row-margin-30 {
		margin: 30px 0;
	}
  .forget {
    margin: 120px auto 30px auto;
  }
	.box-card {
		width: 750px;
    margin: 0 auto;
	}
	.min-body {
		width: 480px;
		margin: 20px auto;
	}
	.header-h1 {
		padding: 8px 0;
		font-size: 18px;
    font-weight: 400;
    color: red;
    border-bottom: 1px solid #969696;
	}
	.step {
		display: block;
		text-align: center;
		background: #eeeeee;
		color: #666666;
		height: 40px;
    line-height: 40px;
	}
	.step.active {
		background: red;
		color: white;
	}
	.can-not-email {
		position: absolute;
    top: 0;
    right: -45px;
		color: red;
		text-decoration: underline;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// pages/account/password/forget.vue